// extracted by mini-css-extract-plugin
module.exports = {"imageCrop":"ImageCrop_imageCrop__3xiOV","reactCrop":"ImageCrop_reactCrop__1dsUl","done":"ImageCrop_done__2Nkfw","closeBtn":"ImageCrop_closeBtn__1kT4N"};